import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'; // Importações do react-router-dom
import './style/App.scss';

// Components
import DesktopNav from './components/navbar/desktop-nav';
import Hero from './components/hero/hero';
import Portfolio from "./components/portfolio/portfolio";
import About from "./components/about/about";
import Contact from "./components/contact/contact";
import Footer from "./components/footer/footer";
import ARPage from './components/ar/ARPage';
import ProjectGallery from './components/project-gallery/ProjectGallery';

class App extends React.Component {
  state = {
    userIsScrolled: false,
    mobileNavbarOpen: false,
  };

  componentDidMount() {
    window.addEventListener("scroll", this.userIsScrolled);
  }
  componentWillUnmount() {
    window.removeEventListener("scroll", this.userIsScrolled);
  }

  userIsScrolled = () => {
    if (window.pageYOffset > 80) {
      this.setState({ userIsScrolled: true });
    } else {
      this.setState({ userIsScrolled: false });
    }
  };

  closeMobileMenu = () => {
    this.setState({ mobileNavbarOpen: false });
  };

  mobileMenuOpen = () => {
    this.setState({ mobileNavbarOpen: true });
  };

  render() {
    return (
      <Router>
        <div className="App">
          <DesktopNav userIsScrolled={this.state.userIsScrolled} />
          <Switch>
            <Route exact path="/">
              <Hero />
              <Portfolio />
              <About />
              <Contact />
              <Footer />
            </Route>
            <Route path="/project/:id" component={ProjectGallery} />
          </Switch>
        </div>
      </Router>
    );
  }
}

export default App;
